import { func, object, string } from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert, TooltipIcon } from "@components";
import { Trash } from "@assets";
import classnames from "classnames";

export const TimelineTeamMemberRemoveButton = ({
  teamMemberName,
  sectionName,
  onRemove,
  className,
  style,
}) => {
  const { t } = useTranslation();
  const [ isOpen, setIsOpen ] = useState(false);

  const handleOpen = (event) => {
    event.stopPropagation();
    setIsOpen(true);
  };

  const handleRemove = () => {
    onRemove();
    setIsOpen(false);
  };

  return (
    <>
      <TooltipIcon
        icon={<Trash color="error" />}
        onClick={handleOpen}
        className={classnames("button-remove noDrag hoverIcon text-sm p-0-5", className)}
        style={style}
      >
        {t("views.editor.remove_resource")}
      </TooltipIcon>
      <Alert
        isOpen={isOpen}
        title={t("views.editor.timeline_table.remove_team_member_alert", {
          teamMemberName,
          sectionName,
        })}
        cancelText={t("common.cancel")}
        acceptText={t("common.confirm_remove")}
        onCancel={() => setIsOpen(false)}
        onAccept={handleRemove}
      />
    </>
  );
};

TimelineTeamMemberRemoveButton.propTypes = {
  teamMemberName: string,
  sectionName: string,
  onRemove: func.isRequired,
  className: string,
  style: object,
};
